import { generateUuidV4 } from 'reactApp/utils/helpers';

export const VIRTUAL_LIST_LOADER_ID = generateUuidV4();
